import React from 'react';

/**
 * Inline loop buttons like djay.app
 * Loop sizes: 1, 2, 4, 8, 16, 32, 64 beats
 * Click to activate, click again to deactivate (toggle)
 * Responsive: wraps on smaller screens
 */
const LoopButtons = ({ currentSize, onLoopChange, disabled = false }) => {
  const loopSizes = [1, 2, 4, 8, 16, 32, 64];
  
  const handleLoopClick = (size) => {
    if (disabled) return;
    
    if (currentSize === size) {
      // Disable loop if same size clicked (toggle off)
      onLoopChange(null);
    } else {
      // Enable loop with new size
      onLoopChange(size);
    }
  };
  
  return (
    <div className="flex flex-wrap items-center gap-1">
      {loopSizes.map((size) => {
        const isActive = currentSize === size;
        
        return (
          <button
            key={size}
            onClick={() => handleLoopClick(size)}
            disabled={disabled}
            className={`
              flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 rounded-md text-xs font-bold
              transition-all duration-150
              ${isActive
                ? 'bg-sunset-orange text-white shadow-lg scale-105 border-2 border-sunset-orange ring-2 ring-sunset-orange/30'
                : 'bg-slate-700/50 text-slate-300 border border-slate-600/50 hover:bg-slate-600 hover:text-white hover:border-slate-500'
              }
              ${disabled ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}
            `}
            title={isActive ? `Désactiver boucle ${size} temps` : `Activer boucle ${size} temps (quantifié)`}
          >
            {size}
          </button>
        );
      })}
    </div>
  );
};

export default LoopButtons;
